// extracted by mini-css-extract-plugin
export var brand = "_23-9";
export var button = "_23-0";
export var chevron = "_23-v";
export var chevronButton = "_23-w";
export var content = "_23-n";
export var danger = "_23-g";
export var dangerOutlined = "_23-h";
export var dark = "_23-l";
export var darkTheme = "_23-c";
export var extraSmall = "_23-4";
export var fullWidth = "_23-8";
export var ghost = "_23-d";
export var gray = "_23-t";
export var icon = "_23-p";
export var iconButton = "_23-s";
export var iconButtonBorder = "_23-x";
export var iconButtonBorderDark = "_23-y";
export var iconButtonBorderLight = "_23-z";
export var iconLeft = "_23-q";
export var iconRight = "_23-r";
export var large = "_23-1";
export var light = "_23-m";
export var medium = "_23-2";
export var micro = "_23-5";
export var nano = "_23-7";
export var outlined = "_23-k";
export var pending = "_23-a";
export var primary = "_23-i";
export var shadow = "_23-o";
export var small = "_23-3";
export var solidLight = "_23-e";
export var solidLightBrand = "_23-f";
export var spinner = "_23-u";
export var transparent = "_23-j";
export var warning = "_23-b";
export var wideNano = "_23-6";